import { useFormContext, Controller } from 'react-hook-form';
import { FormControlLabel, Switch, SwitchProps } from '@mui/material';
import { FormFieldContainer } from './form-field-container';
import { styled } from '@mui/material/styles';
import './form-toggle-switch-field.scss';

interface IFormSwitchProps extends SwitchProps {
  name: string;
  label: string;
  containerWidth?: number;
  hideLabel?: boolean;
}

export const FormToggleSwitchField = ({
  name,
  label,
  required,
  containerWidth,
  hideLabel = false,
  ...otherProps
}: IFormSwitchProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      rules={{
        required,
      }}
      render={({
        field: { ref, onChange, value, ...otherField },
        formState: { errors },
      }) => {
        const control = (
          <FormToggleSwitchField.Switch
            checked={value}
            onChange={onChange}
            {...otherField}
            {...otherProps}
          />
        );

        return (
          <FormFieldContainer md={containerWidth ?? 12} className="form-switch">
            {hideLabel ? (
              control
            ) : (
              <FormControlLabel
                control={control}
                label={label}
                labelPlacement="start"
              />
            )}
          </FormFieldContainer>
        );
      }}
    />
  );
};

FormToggleSwitchField.Switch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 80,
  height: 48,
  padding: 8,
  '& .MuiSwitch-switchBase': {
    padding: 11,
    //margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(32px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
        opacity: 1,
        border: 0,
        '&:after': {
          opacity: 0,
        },
        '&:before': {
          opacity: 1,
        },
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 26,
    height: 26,
  },
  '& .MuiSwitch-track': {
    borderRadius: 20,
    backgroundColor: theme.palette.mode === 'light' ? '#a3a3a3' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
    position: 'relative',
    '&:before, &:after': {
      display: 'inline-block',
      position: 'absolute',
      top: '50%',
      width: '50%',
      transform: 'translateY(-50%)',
      color: '#fff',
      textAlign: 'center',
    },
    '&:before': {
      content: "'Yes'",
      left: 4,
      opacity: 0,
    },
    '&:after': {
      content: "'No'",
      right: 4,
    },
  },
}));
